/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Input_PlaceholderInputs */

const en_chat_input_placeholder = /** @type {(inputs: Chat_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about SohanScript...`)
};

const ar_chat_input_placeholder = /** @type {(inputs: Chat_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسأل عن SohanScript...`)
};

const bn_chat_input_placeholder = /** @type {(inputs: Chat_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SohanScript সম্পর্কে জিজ্ঞেস করুন...`)
};

const de_chat_input_placeholder = /** @type {(inputs: Chat_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragen Sie nach SohanScript...`)
};

const es_chat_input_placeholder = /** @type {(inputs: Chat_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pregunte sobre SohanScript...`)
};

const fr_chat_input_placeholder = /** @type {(inputs: Chat_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renseignez-vous sur SohanScript...`)
};

const pt_chat_input_placeholder = /** @type {(inputs: Chat_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergunte sobre SohanScript...`)
};

const zh_chat_input_placeholder = /** @type {(inputs: Chat_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`询问 SohanScript...`)
};

const tr_chat_input_placeholder = /** @type {(inputs: Chat_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SohanScript'i sorun...`)
};

const ru_chat_input_placeholder = /** @type {(inputs: Chat_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спросите о SohanScript...`)
};

const pl_chat_input_placeholder = /** @type {(inputs: Chat_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapytaj o SohanScript...`)
};

/**
* | output |
* | --- |
* | "Ask about SohanScript..." |
*
* @param {Chat_Input_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const chat_input_placeholder = /** @type {((inputs?: Chat_Input_PlaceholderInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Input_PlaceholderInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_chat_input_placeholder(inputs)
	if (locale === "bn") return bn_chat_input_placeholder(inputs)
	if (locale === "de") return de_chat_input_placeholder(inputs)
	if (locale === "es") return es_chat_input_placeholder(inputs)
	if (locale === "fr") return fr_chat_input_placeholder(inputs)
	if (locale === "pt") return pt_chat_input_placeholder(inputs)
	if (locale === "zh") return zh_chat_input_placeholder(inputs)
	if (locale === "tr") return tr_chat_input_placeholder(inputs)
	if (locale === "ru") return ru_chat_input_placeholder(inputs)
	if (locale === "pl") return pl_chat_input_placeholder(inputs)
	return en_chat_input_placeholder(inputs)
});